import { useSearchParams } from 'react-router-dom';

export const useDataGridSearchParams = (
  mode: 'client' | 'server',
  disableSearchParamSync: boolean,
  additionalQueryArgs?: string
) => {
  const [searchParams] = useSearchParams();
  const currentSearchParams = disableSearchParamSync ? '' : searchParams.toString();

  /** Assemble all url params */
  const additionalQueryArgsString = additionalQueryArgs
    ? currentSearchParams
      ? `&${additionalQueryArgs}`
      : `${additionalQueryArgs}`
    : '';

  if (mode === 'server') {
    return currentSearchParams || additionalQueryArgsString
      ? `?${currentSearchParams}${additionalQueryArgsString}`
      : '';
  }

  // return for client state
  return additionalQueryArgsString ? `?${additionalQueryArgsString}` : '';
};
